import type { CurrentRefinementsProps } from 'react-instantsearch';

import { FILTER_BAR_CONSTANTS } from '../../../FilterBar/Dropdowns';

const transformItems: CurrentRefinementsProps['transformItems'] = items => {
  return items.reduce(
    (acc, item) => {
      if (item.attribute === 'duration') {
        const groupedRefinements: Record<string, unknown[]> = {};

        item.refinements.forEach(refinement => {
          const durationOption = FILTER_BAR_CONSTANTS.durationOptions.find(
            option => {
              const { start, end } = JSON.parse(
                decodeURIComponent(option.value)
              );
              return (
                (refinement.operator === '>=' && refinement.value === start) ||
                (refinement.operator === '<=' && refinement.value === end)
              );
            }
          );

          const newRefinement = durationOption
            ? { ...refinement, label: durationOption.label }
            : refinement;

          const { label } = newRefinement;
          if (!groupedRefinements[label]) groupedRefinements[label] = [];
          groupedRefinements[label].push(newRefinement);
        });

        const newRefinements = Object.values(groupedRefinements).map(group => {
          const [first] = group as unknown[] as typeof item.refinements;
          return { ...first, label: first.label };
        });

        acc.push({ ...item, refinements: newRefinements });
      } else {
        acc.push(item);
      }

      return acc;
    },
    [] as typeof items
  );
};

export { transformItems };
